<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-card>
        <Title title="今日の作業予定" dense icon="mdi-calendar" @click="isExpand = !isExpand">
            <v-progress-circular v-if="$vuetify.breakpoint.xs && isRefreshing" indeterminate size="20" />
            <v-spacer />
            <v-btn small icon elevation="0" @click.stop="isExpand = !isExpand">
                <v-icon v-if="isExpand">mdi-chevron-up</v-icon>
                <v-icon v-if="!isExpand">mdi-chevron-down</v-icon>
            </v-btn>
        </Title>
        <v-expand-transition>
            <v-card-text v-if="isExpand" class="pa-1">
                <v-simple-table v-if="!$vuetify.breakpoint.xs && !isRefreshing" fixed-header dense>
                    <thead>
                        <tr>
                            <th class="text-left">圃場</th>
                            <th class="text-left">作業名</th>
                            <th class="text-left">作業内容</th>
                            <th class="text-center">開始予定日</th>
                            <th class="text-center">終了予定日</th>
                            <th class="text-center"><span>開始予定からの</span><br/><span>経過日数</span></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="work in works" :key="work.body.workID" :style="'backgroundColor:'+(work.isOverScheduleEndDate ? 'rgba(255,0,0,0.1)' : '')" @click="onClickWork(work)">
                            <td class="text-left">{{work.placeName}}</td>
                            <td class="text-left">{{work.body.name}}</td>
                            <td class="text-left">{{getWorkTypeName(work)}}</td>
                            <td class="text-center">{{work.body.scheduleDate.startDate}}</td>
                            <td class="text-center">{{work.body.scheduleDate.endDate}}</td>
                            <td v-if="work.interval != -1" class="text-center">{{work.interval}}日</td>
                            <td v-else class="text-center">---</td>
                        </tr>
                    </tbody>
                </v-simple-table>
                <v-simple-table v-else-if="$vuetify.breakpoint.xs && !isRefreshing" fixed-header dense>
                    <tbody>
                        <tr>
                            <td class="pr-2 pl-2">
                                <v-container fluid class="pa-0">
                                    <v-row dense>
                                        <v-col class="pa-0">
                                            <v-card v-for="work in works" :key="work.body.workID" :style="'backgroundColor:'+(work.isOverScheduleEndDate ? 'rgba(255,0,0,0.1)' : '')" @click="onClickWork(work)" class="mb-2 mt-2 pa-1">
                                                <span class="body-2">{{work.body.name}}【{{getWorkTypeName(work)}}】<br/></span>
                                                <span class="caption">圃場:{{work.placeName}}<br/></span>
                                                <span style="font-size:xx-small">作業予定期間:{{work.body.scheduleDate.startDate}}～{{work.body.scheduleDate.endDate}}<br/></span>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
                <div v-else style="width:100%; text-align:center; height:200px;">
                    <v-progress-circular style="margin-top:100px" indeterminate />
                </div>
            </v-card-text>
        </v-expand-transition>
        <!-- <WorkRecorder
            ref="workRecorder"
            :place="selectedWorkPlace"
            :workTypes="workTypes"
            :composts="composts"
            :fertilizeries="fertilizeries"
            :pesticides="pesticides" /> -->
        <WorkRecorder
            ref="workRecorder" />
        <Confirm ref="confirm" />
    </v-card>
</template>

<script>
    Date.prototype.toFormatString = function (format) {
        const year = this.getFullYear()
        const month = this.getMonth() + 1
        const month2 = ("0" + month).slice(-2)
        const day2 = ("0" + this.getDate()).slice(-2)
        const hour2 = ("0" + this.getHours()).slice(-2)
        const minute2 = ("0" + this.getMinutes()).slice(-2)
        const second2 = ("0" + this.getSeconds()).slice(-2)

        const formattedValue = format.replace("yyyy", year).replace("MM", month2).replace("dd", day2).replace("HH", hour2).replace("mm", minute2).replace("ss", second2)

        return formattedValue
    }

    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import WorkRecorder from '@/components/place/RecorderPlaceWork'
    import Confirm from '@/components/tools/ConfirmDialog';
    export default {
        components: {
            Title,
            WorkRecorder,
            Confirm
        },
        computed: {
            userUID: function () {
                return this.$store.getters["userUID"]
            },
            userData: function () {
                return this.$store.getters["userData"]
            },
            /**
             * 共有モード
             */
            shareMode: function () {
                return this.$store.getters["shareMode"]
            },
            /**
             * 共有モードの全種類
             */
            shareModeTypes: function () {
                return this.$store.getters["shareModeTypes"]
            },
            /** グループユーザーの圃場管理を参照中は True */
            isShareMode: function () {
                if (this.shareMode == this.shareModeTypes.groupUserWork) {
                    return true
                }
                return false
            },
            /**
             * ログインしているユーザーのユーザーUID
             */
            loggedInUserUID: function () {
                return this.$store.getters["loggedInUserUID"]
            },
            /** ログインユーザーの圃場データ */
            loggedInUserPlaceData: function () {
                return this.$store.getters["managementItems/loggedInUserPlaceData"]
            },
            /* グループユーザーの圃場データ */
            groupUserPlaceData: function () {
                return this.$store.getters["managementItems/groupUserPlaceData"]
            },
            /**
             * 共有中に参照しているユーザーが所属しているグループでの自分のユーザーデータ
             */
            shareUserGroupMyUserData: function () {
                return this.$store.getters["managementItems/shareUserGroupMyUserData"]
            },
        },
        data: function () {
            return {
                places: [],
                works: [],
                selectedWork: null,
                selectedWorkPlace: null,
                // cultivationTypes: [],
                // composts: [],
                // fertilizeries: [],
                // pesticides: [],
                isExpand: true,
                isRefreshing: false
            }
        },
        watch: {
            isShareMode: function (value, old) {
                if (!this.isShareMode) {
                    this.refresh(this.loggedInUserPlaceData)
                } else {
                    this.refresh(this.groupUserPlaceData)
                }
            },
            "loggedInUserPlaceData.places": {
                handler: function (value, old) {
                    this.refresh(this.loggedInUserPlaceData)
                },
                deep: true
            },
            "groupUserPlaceData.places": {
                handler: function (value, old) {
                    if (this.isShareMode) {
                        this.refresh(this.groupUserPlaceData)
                    }
                },
                deep: true
            },
            
            // userUID: function (value, old) {
            //     if (value == null || value == "") {
            //         this.works = []
            //     } else {
            //         this.refresh()
            //     }
            // }
        },
        created: function () {
            if (!this.isShareMode) {
                this.refresh(this.loggedInUserPlaceData)
            } else {
                this.refresh(this.groupUserPlaceData)
            }
        },
        methods: {
            /**
             * 一覧の作業押下時
             */
            onClickWork: function (work) {
                // console.log("ScheduleList", "onClickWork", work)
                this.showWorkRecorder(work)
            },
            /**
             * 指定された権限を全て持つか否かを返す(共有中ではない時は、必ず True。共有中はチェック結果を返す)
             */
            checkAuthority: function (place, authorities) {
                if (!this.isShareMode) {
                    return true
                }

                if (place.authorities == null) {
                    return false
                }

                const groupAuthorities = place.authorities.find((v)=>v.ownerUserUID == this.shareUserGroupMyUserData.ownerUserUID && v.groupNo == this.shareUserGroupMyUserData.groupNo)
                const userAuthorities = groupAuthorities != null ? groupAuthorities.users[this.loggedInUserUID] : null

                // console.log("checkAuthority", place, this.shareUserGroupMyUserData, this.loggedInUserUID, groupAuthorities, userAuthorities)

                if (userAuthorities != null) {
                    for (var authority of authorities) {
                        if (userAuthorities.findIndex((v)=>v == authority) < 0) {
                            console.log("user authority", authority, "deny!!")
                            return false
                        }
                        console.log("user authority", authority, "allow!!")
                    }
                    console.log("user authority", "all allow!!", authorities, userAuthorities)
                    return true
                }

                if (this.mi_checkGroupUserAuthority(place.body, authorities)){
                    return true
                }
                return false
            },
            /**
             * 一覧の表示を更新
             */
            refresh: async function (placeData) {
                
                // console.log("ScheduleList", "refresh", placeData)
                
                const userUID = this.$store.getters["userUID"]
                const self = this

                this.isRefreshing = true

                try {
                    this.places = placeData.places

                    this.works = []

                    const currentDate = (new Date()).toFormatString("yyyy-MM-dd")

                    // console.log(this.works)

                    placeData.places.forEach(function(place){
                        if (self.checkAuthority(place, ["browse", "work"])) {
                            place.works.filter((v)=>!v.isCompleted).forEach(function(work){
                                if (work.scheduleDate.startDate == "" || work.scheduleDate.startDate <= currentDate) {
                                    var interval = 0
                                    if (work.scheduleDate.startDate == "") {
                                        interval = -1
                                    } else {
                                        const start = (new Date(work.scheduleDate.startDate)).getTime()
                                        const today = (new Date(currentDate)).getTime()
                                        interval = (today - start) / 86400000
                                    }
                                    var isOverScheduleEndDate = false
                                    if (work.scheduleDate.endDate != "" && currentDate > work.scheduleDate.endDate) {
                                        isOverScheduleEndDate = true
                                    }
                                    self.works.push(
                                        {
                                            body: work,
                                            placeName: place.body.name,
                                            interval: interval,
                                            isOverScheduleEndDate: isOverScheduleEndDate
                                        }
                                    )
                                }
                            })
                        }
                    })

                } catch (error) {
                    console.error("ScheduleList", "refresh", error)
                } finally {
                    this.isRefreshing = false
                }
            },
            /**
             * 指定された作業の作業内容を返す
             */
            getWorkTypeName: function (work) {
                const workType = this.getWorkType(work)
                if (workType == null) {
                    return "unknown"
                }
                return workType.name
            },
            /**
             * 指定された作業の作業種類を返す
             */
            getWorkType: function (work) {

                const targetPlace = this.places.find((v)=>v.body.placeID == work.body.placeID)

                if (targetPlace == null) return null

                var workType = null
                if (work.body.workTypeID <= 100) {
                    if (targetPlace.workTypes == null) return null
                    workType = targetPlace.workTypes.find((v)=>v.workTypeID == work.body.workTypeID)
                } else {
                    if (targetPlace.userWorkTypes == null) return null
                    workType = targetPlace.userWorkTypes.find((v)=>v.workTypeID == work.body.workTypeID)
                }

                // console.log(work.body.workTypeID, work.body.name, workType, targetPlace)

                return workType
            },
            /**
             * 指定された作業の作業記録を行う為に、作業記録画面を表示する
             */
            showWorkRecorder: async function (work) {

                // console.log("ScheduleList", "showWorkRecorder", "start -----------")

                const userUID = this.$store.getters["userUID"]
                const self = this

                // 対象の場所
                this.selectedWorkPlace = this.places.find((v)=>v.body.placeID == work.body.placeID)                    

                if (this.isShareMode && this.checkAuthority(this.selectedWorkPlace, ["work.record"]) == false) {
                    this.$refs.confirm.show({
                        title: "作業記録不可",
                        message: "この圃場への作業記録は行なえません。",
                        buttonYes: "戻る",
                        buttonNo: "",
                        width: 450,
                    })
                    return
                }

                this.$store.commit("processing", {start:true, message:"作業記録の準備をしています。 お待ち下さい…。"})

                try {
                    // 作業
                    this.selectedWork = work.body

                    // 全作業種類を格納した配列
                    const workTypes = []

                    for (var i=0; i<this.selectedWorkPlace.workTypes.length; i++) {
                        workTypes.push(this.selectedWorkPlace.workTypes[i])
                    }
                    for (var i=0; i<this.selectedWorkPlace.userWorkTypes.length; i++) {
                        workTypes.push(this.selectedWorkPlace.userWorkTypes[i])
                    }

                    // 表示
                    // console.log("ScheduleList", "showWorkRecorder", "show recorder", this.selectedWork.name, this.selectedWorkPlace, this.selectedWork, workTypes)
                    // console.log("ScheduleList", "showWorkRecorder", "end -----------")
                    this.$refs.workRecorder.show(this.selectedWorkPlace, workTypes, this.selectedWork)

                } finally {
                    this.$store.commit("processing", {start:false})
                }
            },
        }
    }
</script>
            /**
             * 作業記録の権限があるか否か
             */
            canRecordWork: function () {
                if (!this.isShareMode) return true
                return this.mi_checkGroupUserAuthority(this.targetPlace.body, ["browse", "work", "work.record"])
            },
